import { v4 as uuidv4 } from 'uuid';
import { images } from '../../constants';

const spaceHubData = {
  id: uuidv4,
  title: 'Space Hub Shuttle',
  description: 'An app that allows users to rent their favorite rockets and reserve their space missions.',
  image: images.space,
  liveLink: 'https://space-hub-shuttle.netlify.app/',
  codeLink: 'https://github.com/Carshy/space-traveller-app',
  tags: { react: 'React JS & Redux', rest: 'RESTful API', sass: 'SCSS' },
};

const paradiseData = {
  id: uuidv4,
  title: 'Paradise Cuisine',
  description: 'Paradise Cuisine is an innovative app that enables users to discover, cook, and savor special meals, breakfasts, and dinners from different cultures around the world.',
  image: images.paradise,
  liveLink: 'https://paradise-cuisine.netlify.app/',
  codeLink: 'https://github.com/Carshy/paradise-cuisine',
  tags: {
    react: 'React JS & Redux', js: 'JavaScript', rest: 'RESTful API', sass: 'SCSS',
  },
};

const talantaData = {
  id: uuidv4,
  title: 'Talanta Fountain',
  description: 'Talanta Fountain is a fully responsive web application that I created to showcase the nurturing of youth talents from vulnerable areas in African countries',
  image: images.talantaF,
  liveLink: 'https://talanta-fountain.netlify.app/',
  codeLink: 'https://github.com/Carshy/Talanta-Fountain',
  tags: { js: 'JavaScript', dom: 'DOM', sass: 'SCSS' },
};

const portData = {
  id: uuidv4,
  title: 'Portfolio App',
  description: 'A full-stack app that allows employers to navigate through, and see my skills, experiences, and attributes.',
  image: images.portfolio,
  liveLink: 'https://collins-musoko-portfolio.netlify.app/',
  codeLink: 'https://github.com/Carshy/portfolio-app',
  tags: { react: 'React JS & Redux', sanity: 'Sanity.io', sass: 'SCSS' },
};

const allProjectsData = [paradiseData, spaceHubData, talantaData, portData];

export default allProjectsData;
